import { render, staticRenderFns } from "./CPCart.vue?vue&type=template&id=768f8c64&scoped=true&"
import script from "./CPCart.vue?vue&type=script&lang=ts&"
export * from "./CPCart.vue?vue&type=script&lang=ts&"
import style0 from "./CPCart.vue?vue&type=style&index=0&id=768f8c64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768f8c64",
  null
  
)

export default component.exports